import { SEARCH_DONTMISS_BY_DROPDOWN, SEARCH_DONTMISS_BY_SYMBOL, WATCHLIST } from "../actionTypes";

const initialState = {
    dontMissInfo: [],
    whatsHotData: [],
    dontMissData: [],
    strSearchDontMissBySymbol: '',
    arrSearchDontMissByDropdown: [],
    groupedDontMissData: []

};

const dontMissReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case WATCHLIST.GET_WHATS_HOT_DATA_SUCCESS:
            return {
                ...state,
                whatsHotData: actions.payload
            };
        case WATCHLIST.GET_WHATS_HOT_DATA_FAILURE:
            return {
                ...state,
                whatsHotData: actions.payload
            };
        case WATCHLIST.UPDATE_GROUPED_DONT_MISS:
            return {
                ...state,
                groupedDontMissData: actions.payload
            }
        case WATCHLIST.GET_DONT_MISS_DATA:
            return {
                ...state,
                dontMissData: actions.payload
            };
        case SEARCH_DONTMISS_BY_SYMBOL:
            return {
                ...state,
                strSearchDontMissBySymbol: actions.payload
            };
        case SEARCH_DONTMISS_BY_DROPDOWN:
            return {
                ...state,
                arrSearchDontMissByDropdown: actions.payload
            };

        default:
            return state;
    }

};

export default dontMissReducer;